module.exports = __webpack_public_path__ + "fonts/SourceHanSansSC-Bold-subset.48a8d400.woff";